import { render, staticRenderFns } from "./salesrevorder.vue?vue&type=template&id=2170758e"
import script from "./salesrevorder.vue?vue&type=script&lang=js"
export * from "./salesrevorder.vue?vue&type=script&lang=js"
import style0 from "./salesrevorder.vue?vue&type=style&index=0&id=2170758e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports